import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { useNavigate } from 'react-router-dom';

export default function SignUpCard() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/register');
  };

  return (
    <Card className="w-[350px] mx-auto mt-4 pt-6 text-gray-700">
      <CardContent>
        This site is for Wayne Manor current members and alumni only. Please use the email you receive newsletters or other emails to log in. If you continue to have issues, please <a className="text-blue-500" href='/register'>register</a>.
      </CardContent>
    </Card>
  );
}